"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scientificNotationToDecimal = void 0;
function scientificNotationToDecimal(value) {
    var sign = Math.sign(Number(value));
    //if the number is in scientific notation remove it
    if (/\d+\.?\d*e[\+\-]*\d+/i.test(String(value))) {
        var zero = "0";
        var parts = String(value).toLowerCase().split("e"); //split into coeff and exponent
        var e = parts.pop(); //store the exponential part
        var l = Math.abs(Number(e)); //get the number of zeros
        var direction = Number(e) / l; // use to determine the zeroes on the left or right
        var coeff_array = parts[0].split(".").map(function (i) { return Number(i); });
        if (direction === -1) {
            coeff_array[0] = Math.abs(Number(coeff_array[0]));
            value = zero + "." + new Array(l).join(zero) + coeff_array.join("");
        }
        else {
            var dec = coeff_array[1];
            if (dec)
                l = l - dec.toString().length;
            value = coeff_array.join("") + new Array(l + 1).join(zero);
        }
    }
    if (sign < 0 && value > 0) {
        value = -value;
    }
    return String(value);
}
exports.scientificNotationToDecimal = scientificNotationToDecimal;
//# sourceMappingURL=scientificNotation.js.map